<section class="p-8">
  <div class="max-w-[800px] w-full">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
      <app-vet-care-service-card
        data-automationid="vet-care-service-card-vet-chat"
        class="block h-full"
        title="Chat with a vet"
        subtitle="Message a RCVS qualified vet for expert care and advice."
        [type]="'Vet-Chat'"
        [iconSrc]="'assets/svgs/chat-illustration.svg'"
        [status]="data?.chat_availability_status()"
        [statusText]="data?.chat_availability_label()"
        [inActiveChat]="false"
        (click)="onChatCardClick(chatStatusEnum.curious)"
      />
      <app-vet-care-service-card
        data-automationid="vet-care-service-card-vet-chat-ai"
        class="block h-full"
        title="AI chat triage"
        subtitle="Triage with our AI vet to get instant advice and guidance."
        [type]="'Vet-Chat'"
        [iconSrc]="'assets/svgs/chat-illustration-ai.svg'"
        [status]="'available'"
        [statusText]="'Available now'"
        [inActiveChat]="false"
        (click)="onChatCardClick(chatStatusEnum.llmChatTriage)"
      />
      <app-vet-care-service-card
        data-automationid="vet-care-service-card-vet-chat-ai-general"
        class="block h-full"
        title="AI chat triage V2"
        subtitle="Triage with our AI vet to get instant advice and guidance using the general triage model"
        [type]="'Vet-Chat'"
        [iconSrc]="'assets/svgs/chat-illustration-ai.svg'"
        [status]="'available'"
        [statusText]="'Available now'"
        [inActiveChat]="false"
        (click)="onChatCardClick(chatStatusEnum.aIGeneralTriage)"
      />
    </div>
  </div>
</section>
